import { View, Text, Pressable, StyleSheet } from 'react-native'
import { Shield, Menu, X } from 'lucide-react-native'
import { useRouter } from 'expo-router'
import { colors, spacing } from '../theme'

interface MobileHeaderProps {
  sidebarOpen: boolean
  onToggleSidebar: () => void
}

export default function MobileHeader({ sidebarOpen, onToggleSidebar }: MobileHeaderProps) {
  const router = useRouter()

  return (
    <View style={styles.header}>
      <Pressable onPress={() => router.navigate('/(tabs)/' as any)} style={styles.logoRow}>
        <Shield size={28} color={colors.primary} />
        <Text style={styles.logoText}>ForbrugerAgenten</Text>
      </Pressable>
      <Pressable
        onPress={onToggleSidebar}
        style={styles.menuButton}
        accessibilityLabel={sidebarOpen ? 'Luk menu' : 'Åbn menu'}
        accessibilityRole="button"
      >
        {sidebarOpen ? (
          <X size={24} color={colors.text.primary} />
        ) : (
          <Menu size={24} color={colors.text.primary} />
        )}
      </Pressable>
    </View>
  )
}

export const MOBILE_HEADER_HEIGHT = 56

const styles = StyleSheet.create({
  header: {
    height: MOBILE_HEADER_HEIGHT,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: spacing.md,
    backgroundColor: colors.background,
    borderBottomWidth: 1,
    borderBottomColor: colors.border,
    zIndex: 60,
  },
  logoRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  logoText: {
    fontSize: 18,
    fontWeight: '700',
    color: colors.text.primary,
  },
  menuButton: {
    width: 44,
    height: 44,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 10,
  },
})
